import React from "react";
import OperatorServiceTickets from "../../components/dashboard/OperatorServiceTickets";

const OperatorDomiciliation = () => (
  <OperatorServiceTickets
    serviceCode="domiciliation"
    title="Domiciliation"
    lead="Les demandes des entreprises domiciliées chez Platform98."
  />
);

export default OperatorDomiciliation;
